import { SettingConst } from '../../types';

/**
 * "
 *         Enable the pdp attribute encrichment experience for retailer.
 *         Retailers in the treatment will see pdp attributes displayed in updated design.
 */
export const ENABLE_PDP_ATTRIBUTES_ENRICHMENT_241010 =
  'ENABLE_PDP_ATTRIBUTES_ENRICHMENT_241010' as SettingConst<
    'ENABLE_PDP_ATTRIBUTES_ENRICHMENT_241010',
    boolean,
    'LOGGED_IN_RETAILER'
  >;
